import script from './component-lib.esm6.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('button', _vm._b({
    staticClass: "v-tab",
    class: _vm.classes,
    attrs: {
      "role": "tab",
      "id": _vm.kebabCase(_vm.value) + "-tab",
      "aria-selected": _vm.isActive.toString(),
      "tabIndex": _vm.isActive ? 0 : -1,
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'button', _vm.$attrs, false), [_vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "v-tab__indicator",
    attrs: {
      "data-flip": _vm.value
    }
  })], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-b3207906_0", {
    source: ".v-tab[data-v-b3207906]{background:0 0;color:var(--g-color-gray-600);border:none;cursor:pointer;font-family:var(--g-font-body-family);font-size:1rem;font-weight:700;padding:.85rem .65rem;position:relative;transition:color var(--g-transition-speed) ease-out,background var(--g-transition-speed) ease-out}@media (min-width:768px){.v-tab[data-v-b3207906]{padding:.85rem}}.v-tab[data-v-b3207906]:focus,.v-tab[data-v-b3207906]:hover{background:var(--c-tab-accent-color)}.v-tab--active[data-v-b3207906],.v-tab[data-v-b3207906]:focus,.v-tab[data-v-b3207906]:hover{color:var(--c-tab-color)}.v-tab[data-v-b3207906]:disabled{pointer-events:none;opacity:.7}.v-tab__indicator[data-v-b3207906]{left:0;opacity:0;position:absolute;top:100%;width:100%;border-bottom:4px solid var(--c-tab-color)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-b3207906";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };